/**
 * ambientTimeService — applies a subtle time-of-day color class to <html>.
 * Updates every 30 minutes. CSS variables handle the actual color shifts.
 */

const TIME_CLASSES = ['ambient-morning', 'ambient-evening', 'ambient-night'] as const;

function getTimeClass(): string | null {
  const h = new Date().getHours();
  if (h >= 5 && h < 12) return 'ambient-morning';
  if (h >= 18 && h < 22) return 'ambient-evening';
  if (h >= 22 || h < 5) return 'ambient-night';
  return null; // afternoon — default palette, no class needed
}

export function applyAmbientTime(): () => void {
  function update() {
    const root = document.documentElement;
    TIME_CLASSES.forEach((c) => root.classList.remove(c));
    const cls = getTimeClass();
    if (cls) root.classList.add(cls);
  }

  update();
  const id = setInterval(update, 30 * 60 * 1000);
  return () => clearInterval(id);
}
